import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router';
import { Loader2, AlertCircle } from 'lucide-react';
import { useDarkMode } from '../context/DarkModeContext';
import { api } from '../lib/api';

/** Löst einen einmaligen Admin-Login-Link ein: tauscht den Token gegen ein JWT,
 *  speichert es und lädt die App als Ziel-User neu. Bewusst public (eigener Browser). */
export default function LoginLinkPage() {
  const { token } = useParams<{ token: string }>();
  const { darkMode } = useDarkMode();
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) return;
    api.post<{ access_token: string }>(`/api/auth/impersonate/${token}`, {})
      .then(res => {
        localStorage.setItem('auth_token', res.access_token);
        sessionStorage.removeItem('expiry_modal_shown');
        // Voller Reload, damit der AuthContext den neuen Token frisch einliest.
        window.location.href = '/';
      })
      .catch(e => setError(e instanceof Error ? e.message : 'Login-Link ungültig oder abgelaufen'));
  }, [token]);

  const base = `min-h-screen flex items-center justify-center p-4 ${darkMode ? 'bg-slate-900 text-white' : 'bg-slate-100 text-slate-900'}`;
  const card = `w-full max-w-md rounded-2xl shadow-lg p-8 text-center ${darkMode ? 'bg-slate-800' : 'bg-white'}`;

  if (error) return (
    <div className={base}>
      <div className={card}>
        <AlertCircle className="w-10 h-10 text-red-500 mx-auto mb-3" />
        <h1 className="text-lg font-semibold mb-2">Login fehlgeschlagen</h1>
        <p className={`text-sm mb-4 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>{error}</p>
        <Link to="/login" className="text-blue-500 hover:underline text-sm">Zum normalen Login</Link>
      </div>
    </div>
  );

  return (
    <div className={base}>
      <div className={card}>
        <Loader2 className="w-8 h-8 animate-spin text-blue-600 mx-auto mb-3" />
        <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Anmeldung läuft…</p>
      </div>
    </div>
  );
}
